module.exports = __webpack_public_path__ + "img/4.79e567c6.png";